import React from 'react';
import { Form, Select, Input, Radio } from 'antd';
import { FORM_FIELDS, INPUT_VALUE_MAX_LENGTH, RESULT_OPTIONS } from '../../constants';
import { FIELD_DISABLED_BY_SUPPLY_SOURCE } from '../constants';
import { CAS } from '../../AuctionSnapshotDetailedView/constants';
import { StyledFieldsWrapper, StyledProfileSelect } from '../styles';

const { Option } = Select;

export const UserParametersSection = (props) => {
  const {
    profileTypes,
    handleChangeSelectType,
    isProfilesLoading,
    isSelectTypeValue,
    handleChangeProfile,
    handleProfilesFilter,
    handleClearUserProfile,
    profiles,
    handleClearSupplySource,
    handleChangeField,
    getOptionsByFieldName,
    getSupplySources,
    supplySource,
    handleClearAppName,
    renderOptions,
    userProfile,
    publisher,
    onSupplySourceChangeResetFields,
    podPosition,
  } = props;
  return (
    <StyledFieldsWrapper>
      <Form.Item label={FORM_FIELDS.SELECT_TYPE.label} name={FORM_FIELDS.SELECT_TYPE.name}>
        <Select onChange={handleChangeSelectType} placeholder="Select" options={profileTypes} allowClear />
      </Form.Item>
      <Form.Item
        label={FORM_FIELDS.USER_PROFILE.label}
        name={FORM_FIELDS.USER_PROFILE.name}
        loading={isProfilesLoading}
      >
        <StyledProfileSelect
          showSearch
          disabled={!isSelectTypeValue || isProfilesLoading}
          optionFilterProp="label"
          placeholder="Select"
          onChange={handleChangeProfile}
          filterOption={handleProfilesFilter}
          onClear={handleClearUserProfile}
          allowClear
          loading={isProfilesLoading}
        >
          {profiles?.currentUser && (
            <Select.OptGroup label="My Profiles">
              {profiles?.currentUser.map((profile) => (
                <Select.Option value={profile.value} key={profile.id}>
                  {profile.label}
                </Select.Option>
              ))}
            </Select.OptGroup>
          )}
          <Select.OptGroup label="All Profiles">
            {profiles?.allUsers?.map((profile) => (
              <Select.Option value={profile.value} key={profile.id}>
                {profile.label}
              </Select.Option>
            ))}
          </Select.OptGroup>
        </StyledProfileSelect>
      </Form.Item>
      <Form.Item
        label={FORM_FIELDS.SUPPLY_SOURCE.label}
        name={FORM_FIELDS.SUPPLY_SOURCE.name}
        rules={[{ required: true, message: 'Supply Source is required!' }]}
      >
        <Select
          placeholder="Select"
          onClear={handleClearSupplySource}
          onChange={(value) => {
            handleChangeField({ fieldName: FORM_FIELDS.SUPPLY_SOURCE.name, value });
            onSupplySourceChangeResetFields();
          }}
          allowClear
        >
          {(getOptionsByFieldName(FORM_FIELDS.SUPPLY_SOURCE.name).length > 0
            ? getOptionsByFieldName(FORM_FIELDS.SUPPLY_SOURCE.name)
            : getSupplySources()
          )?.map((supplySource) => (
            <Option value={supplySource} key={supplySource}>
              {supplySource}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label={FORM_FIELDS.APP_NAME.label}
        name={FORM_FIELDS.APP_NAME.name}
        rules={[{ required: true, message: 'Publisher is required!' }]}
      >
        <Select
          placeholder="Select"
          disabled={!supplySource}
          allowClear
          onClear={handleClearAppName}
          onChange={(value) => handleChangeField({ fieldName: FORM_FIELDS.APP_NAME.name, value })}
        >
          {getOptionsByFieldName(FORM_FIELDS.APP_NAME.name).map(renderOptions)}
        </Select>
      </Form.Item>
      <Form.Item label={FORM_FIELDS.DISTRIBUTOR.label} name={FORM_FIELDS.DISTRIBUTOR.name}>
        <Select
          placeholder="Select"
          allowClear
          onChange={(value) => handleChangeField({ fieldName: FORM_FIELDS.DISTRIBUTOR.name, value })}
        >
          {getOptionsByFieldName(FORM_FIELDS.DISTRIBUTOR.name).map(renderOptions)}
        </Select>
      </Form.Item>
      <Form.Item
        label={FORM_FIELDS.COUNTRY.label}
        name={FORM_FIELDS.COUNTRY.name}
        rules={[{ required: supplySource === CAS, message: 'Country is required!' }]}
      >
        <Select
          placeholder="Select"
          disabled={
            !supplySource || !publisher || FIELD_DISABLED_BY_SUPPLY_SOURCE?.[FORM_FIELDS?.COUNTRY?.name]?.[supplySource]
          }
          allowClear
          onChange={(value) => handleChangeField({ fieldName: FORM_FIELDS.COUNTRY.name, value })}
        >
          {getOptionsByFieldName(FORM_FIELDS.COUNTRY.name).map(renderOptions)}
        </Select>
      </Form.Item>
      <Form.Item label={FORM_FIELDS.ADVERTISER.label} name={FORM_FIELDS.ADVERTISER.name}>
        <Input allowClear />
      </Form.Item>
      <Form.Item label={FORM_FIELDS.POD_POSITION.label} name={FORM_FIELDS.POD_POSITION.name}>
        <Select placeholder="Select" allowClear>
          {podPosition?.map(renderOptions)}
        </Select>
      </Form.Item>
      <Form.Item label={FORM_FIELDS.CREATIVE_ID.label} name={FORM_FIELDS.CREATIVE_ID.name}>
        <Input allowClear />
      </Form.Item>
      <Form.Item
        label={FORM_FIELDS.INPUT_VALUE.label}
        name={FORM_FIELDS.INPUT_VALUE.name}
        info="Info Text"
        rules={[
          {
            required: !!userProfile,
            message: `${FORM_FIELDS.INPUT_VALUE.label} is required!`,
          },
        ]}
      >
        <Input disabled={userProfile || !isSelectTypeValue} maxLength={INPUT_VALUE_MAX_LENGTH} showCount allowClear />
      </Form.Item>
      <Form.Item label={FORM_FIELDS.SESSION_ID.label} name={FORM_FIELDS.SESSION_ID.name}>
        <Input
          disabled={!supplySource || FIELD_DISABLED_BY_SUPPLY_SOURCE?.[FORM_FIELDS?.SESSION_ID?.name]?.[supplySource]}
          allowClear
        />
      </Form.Item>
      <Form.Item label={FORM_FIELDS.RESULT.label} name={FORM_FIELDS.RESULT.name}>
        <Radio.Group options={RESULT_OPTIONS} />
      </Form.Item>
    </StyledFieldsWrapper>
  );
};
